<template>
    <div class="lazy-editor">
        <div v-if="!editorLoaded">
            <div class="preview-header">
                <span class="preview-label">{{ label }}</span>
                <v-btn v-if="!readOnly" small dark color="black" @click="loadEditor">
                    <v-icon small left>mdi-pencil</v-icon>
                    Edit content
                </v-btn>
            </div>
            <div class="content-preview" v-html="value" />
        </div>
        <editor
            v-else
            :id="editorId"
            :value="value"
            :api-key="tinymceApiKey"
            :init="mergedInit"
            @input="$emit('input', $event)"
        />
    </div>
</template>

<script>
    import Editor from '@tinymce/tinymce-vue'

    export default {
        name: 'LazyEditor',
        components: { Editor },
        props: {
            value: {
                type: String,
                default: ''
            },
            editorId: {
                type: String,
                required: true
            },
            init: {
                type: Object,
                default: () => ({})
            },
            label: {
                type: String,
                default: 'Content'
            },
            readOnly: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                editorLoaded: false,
                tinymceApiKey: process.env.VUE_APP_TINYMCE_API_KEY
            }
        },
        computed: {
            mergedInit() {
                return {
                    resize: true,
                    statusbar: true,
                    branding: false,
                    elementpath: false,
                    ...this.init
                }
            }
        },
        methods: {
            loadEditor() {
                this.editorLoaded = true
            }
        }
    }
</script>

<style>
/* Keep the statusbar visible so the resize handle is usable.
   Overrides the global `.tox .tox-statusbar { display: none }` rules
   that exist in several forms. */
.tox.tox-tinymce .tox-statusbar {
    display: flex !important;
}
.tox.tox-tinymce .tox-statusbar__text-container {
    visibility: hidden;
}
</style>

<style scoped>
.preview-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}
.preview-label {
    color: rgba(0, 0, 0, 0.6);
}
.content-preview {
    border: 1px solid rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    padding: 16px;
    min-height: 150px;
    max-height: 600px;
    overflow-y: auto;
    resize: vertical;
}
</style>
